<template>
    <QDynamicSubmenu
        :base-url="baseUrl"
        :default-title="title"
        :default-buttons="buttons"
    />
</template>

<script>
//table data + search
import QDynamicSubmenu from '@/components/navigation/Submenus/base/QDynamicSubmenu.vue'

export default {
    name: "QContestsSubmenu",
    data() {
        return {
            title: "Contests",
            baseUrl: '/contests',
            buttons: [
                {
                    label: "News",
                    to: "/news",
                    icon: "fas fa-arrow-alt-circle-right",
                },
                {
                    label: "Contests",
                    anchor: "#Contests",
                    icon: "fas fa-arrow-alt-circle-down",
                },
            ],
        }
    },
    components: {
        QDynamicSubmenu,
    },
}
</script>

<style></style>
